type Props = {
  scrollToForm: () => void;
  useShortText?: boolean;
};

const Component: React.FC<Props> = ({ scrollToForm, useShortText }) => {
  return (
    <button
      className="h-full w-full rounded bg-orange-600 font-bold text-white"
      onClick={scrollToForm}
    >
      {useShortText ? 'いますぐ会員登録' : 'いますぐ会員登録する'}
    </button>
  );
};

export default Component;
